module.exports = __webpack_public_path__ + "static/img/x.7debbc9a.svg";